/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Listingbuttonsnonevisible3Inputs */

const en_listingbuttonsnonevisible3 = /** @type {(inputs: Listingbuttonsnonevisible3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`None of the chosen buttons is available right now – guests see no button row.`)
};

const de_listingbuttonsnonevisible3 = /** @type {(inputs: Listingbuttonsnonevisible3Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Keiner der gewählten Knöpfe ist gerade verfügbar – Gäste sehen keine Knopfreihe.`)
};

/**
* | output |
* | --- |
* | "None of the chosen buttons is available right now – guests see no button row." |
*
* @param {Listingbuttonsnonevisible3Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const listingbuttonsnonevisible3 = /** @type {((inputs?: Listingbuttonsnonevisible3Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Listingbuttonsnonevisible3Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_listingbuttonsnonevisible3(inputs)
	return de_listingbuttonsnonevisible3(inputs)
});
export { listingbuttonsnonevisible3 as "listingButtonsNoneVisible" }